
const zIndex = 2147483647; // an insane z-index to work in fullscreen mode for textbox.io

const DRAWING_MODAL_WIDTH = 970;
const DRAWING_MODAL_HEIGHT = 600;

const MATH_ENTRY_MODAL_WIDTH = 600;
const MATH_ENTRY_MODAL_HEIGHT = 500;

const SNAPSHOTS_MODAL_MAX_WIDTH = 970;

const modalUtils = {
    defaultModalStyles: {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex,
        },
        content: {
            position: 'absolute',
            top: '40px',
            left: '40px',
            right: '40px',
            bottom: '40px',
            border: 'none',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '0px',
            zIndex: (zIndex + 1),
        },
    },
    mathEntryModalStyles: {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex,
        },
        content: {
            position: 'absolute',
            top: `calc(50% - ${MATH_ENTRY_MODAL_HEIGHT / 2}px)`,
            width: `${MATH_ENTRY_MODAL_WIDTH}px`,
            height: `${MATH_ENTRY_MODAL_HEIGHT}px`,
            minHeight: `${MATH_ENTRY_MODAL_HEIGHT}px`,
            left: `calc(50% - ${MATH_ENTRY_MODAL_WIDTH / 2}px)`,
            border: 'none',
            background: '#f9f9f9',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '0px',
            zIndex: (zIndex + 1),
        },
    },
    drawingModalStyles: {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex,
        },
        content: {
            position: 'absolute',
            top: '60px',
            width: `${DRAWING_MODAL_WIDTH}px`,
            height: `${DRAWING_MODAL_HEIGHT}px`,
            minHeight: `${DRAWING_MODAL_HEIGHT}px`,
            left: `calc(50% - ${DRAWING_MODAL_WIDTH / 2}px)`,
            border: 'none',
            background: '#f9f9f9',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '0px',
            zIndex: (zIndex + 1),
        },
    },
    confirmationModalStyles: {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        content: {
            position: 'unset',
            padding: 0,
            border: 'none',
            outline: 'none',
            inset: 'unset',
            width: '50%',
            maxWidth: '600px',
            height: 'auto',
        },
    },
    confirmDeleteDrawingModalStyles: {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex,
        },
        content: {
            position: 'absolute',
            top: '35%',
            width: '35%',
            height: '20%',
            minHeight: '200px',
            left: '35%',
            border: 'none',
            background: '#f9f9f9',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '0px',
            zIndex: (zIndex + 1),
        },
    },
    codeCompilerModalStyles: {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            overflowY: 'auto',
            paddingBottom: '120px',
            zIndex,
        },
        content: {
            position: 'relative',
            top: '60px',
            left: 'initial',
            right: 'initial',
            bottom: 'initial',
            margin: '0 auto',
            width: '100%',
            maxWidth: '1000px',
            height: 'auto',
            minHeight: 'auto',
            border: 'none',
            background: '#f9f9f9',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '0',
            zIndex: (zIndex + 1),
        },
    },
    snapshotsModalStyles: {
        overlay: {
            padding: '10%',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex,
        },
        content: {
            position: 'static',
            width: '100%',
            maxWidth: `${SNAPSHOTS_MODAL_MAX_WIDTH}`,
            top: '10px',
            left: '10px',
            right: '10px',
            bottom: '10px',
            border: 'none',
            background: '#f9f9f9',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '0px',
            display: 'flex',
            zIndex: (zIndex + 1),
        },
    },
};

export default modalUtils;
